import styled, { css } from 'styled-components';

import { tabletPortrait } from '@/components/utils';

import type { DescriptionListVariant } from './DescriptionList.types';

export const variants = {
  primary: css`
    display: grid;
    /* 88px are the max-width of the term column */
    grid-template-columns: minmax(auto, 88px) 1fr;
    grid-gap: var(--distance-static-s);

    @media screen and (${tabletPortrait}) {
      /* 92px are the max-width of the term column */
      grid-template-columns: minmax(auto, 92px) 1fr;
    }
  `,
  secondary: null,
};

interface StyledDescriptionList {
  $variant: DescriptionListVariant;
}

export const StyledDescriptionList = styled.dl<StyledDescriptionList>`
  margin: 0;
  font-size: var(--font-size-static-s);
  line-height: var(--line-height-static-m);

  ${({ $variant }) => variants[$variant]}
`;

export const StyledWrap = styled.div`
  display: grid;
  grid-gap: var(--distance-static-xxs);

  & ~ & {
    margin-top: var(--distance-static-m);
  }

  @media screen and (${tabletPortrait}) {
    grid-template-columns: auto 1fr;
    grid-gap: var(--distance-static-xs);

    & ~ & {
      margin-top: var(--distance-static-xxs);
    }
  }
`;

export const StyledDescriptionTerm = styled.dt`
  font-weight: var(--font-weight-heavy);
`;

export const StyledDescriptionDetails = styled.dd`
  margin: 0;
`;
